export const ItemCodeDropDownData = [
    { item: 'IP-29839', description: 'iPhone X' },
    { item: 'IP-125475', description: 'MacBook' },
    { item: 'IR-29539', description: 'iPhone 14' },
  ];
  export const item_code_DropDownData = [
    { item: 'CH12456', description: 'Controller', itemtype:'Assembly'},
    { item: 'TB23455', description: 'Console',itemtype:'Assembly'},
    { item: 'Ip12344', description: 'Mac Book',itemtype:'Components'},
    { item: 'Ip12333', description: 'Iphone 12',itemtype:'Components' },
    { item: 'Ip12399', description: 'Iphone 15',itemtype:'Components' },
    { item: 'Ip12311', description: 'Mac Book',itemtype:'Components' },
    { item: 'Ip12338', description: 'Iphone 12',itemtype:'Components' },
    { item: 'Ip12300', description: 'Iphone 15',itemtype:'Components' },

];
  